import React from 'react'
import { useState, useMemo, useContext, createContext } from "react";

export const DateContext:any = createContext({});

export const DateProvider = ({ children }) => {
  const [dateFilterState, setDateFilterState] = useState({});

  const value = useMemo(() => [dateFilterState, setDateFilterState], [
    dateFilterState,
    setDateFilterState
  ]);

  return (
    <DateContext.Provider value={value}>{children}</DateContext.Provider>
  );
};
